import { useRecoilState, useRecoilValue, useResetRecoilState } from 'recoil'
import { useParams } from 'react-router'
import {
  AllCheckStatus,
  CertCheckState,
  JoinTermsValue,
  PartnerListData,
  RecoilStateList,
  TelNumState,
  TelTypeState,
  uiData,
} from 'src/recoil/common'
import { CustomBtn, NoticeFeeText } from 'src/styles/styledcomponent/views/RopForm/JoinSubmit'

import useAPI from 'src/hooks/useAPI'
import PageCalling from 'src/components/common/PageCalling'
import { PramsKeys } from 'src/types/type'
import { Rop01JoinSubmitWrap } from 'src/styles/styledcomponent/views/Rop01/JoinSubmit'

const JoinSubmit = (props: any): JSX.Element => {
  const { submit } = props
  const { pcode } = useParams<PramsKeys>()
  const [
    {
      layoutsVerify: { verifyBtn, cancelBtn, cashSpace },
    },
  ] = useRecoilState(uiData)
  const { TelType, PhoneNum, CertNum, authKeyValue, termsAgree, TransId, TermsData } =
    useRecoilValue(RecoilStateList)

  const partnerData = useRecoilValue(PartnerListData)
  const resetPhoneNum = useResetRecoilState(TelNumState)
  const resetCertCheck = useResetRecoilState(CertCheckState)
  const resetTelType = useResetRecoilState(TelTypeState)
  const resetTermsAgree = useResetRecoilState(JoinTermsValue)
  const resetTerms = useResetRecoilState(AllCheckStatus)
  const joinApi = useAPI('requestJoin')

  const { mutateAsync: joinRequest, isLoading: submitLoading } = joinApi.useSetMutation({
    TranID: TransId,
    Telecom: TelType,
    PNumber: PhoneNum,
    ApprovalNumber: Number(CertNum),
    PCode: pcode,
    TermsIdx: TermsData?.TermsIdx,
    TermsAgree: termsAgree.join(""),
    authKey: authKeyValue,
  })
  const isJoinApiPending = submit.isVulnerableCheckPending || submitLoading
  const isJoinBusy = submit.isJoinSubmitting || isJoinApiPending
  return (
    <Rop01JoinSubmitWrap>
      <PageCalling active={isJoinApiPending} />
      <CustomBtn
        id="joinButton"
        {...verifyBtn}
        onClick={() => submit.join(joinRequest)}
        disabled={isJoinBusy}
      >
        {partnerData.ButtonMsgAfter}
      </CustomBtn>
      <CustomBtn
        {...cancelBtn}
        onClick={() => {
          resetPhoneNum()
          resetCertCheck()
          resetTelType()
          resetTermsAgree()
          resetTerms()
        }}
      >
        취소
      </CustomBtn>
      <NoticeFeeText
        cashSpace={cashSpace}
        fontSize={partnerData.FontSize}
        fontColor={partnerData.FontColor}
        dangerouslySetInnerHTML={{ __html: partnerData.NotiContent }}
      />
    </Rop01JoinSubmitWrap>
  )
}
export default JoinSubmit
